import { render, staticRenderFns } from "./Sub-Header.vue?vue&type=template&id=9d284dae&scoped=true"
import script from "./Sub-Header.vue?vue&type=script&lang=js"
export * from "./Sub-Header.vue?vue&type=script&lang=js"
import style0 from "./Sub-Header.vue?vue&type=style&index=0&id=9d284dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d284dae",
  null
  
)

export default component.exports